export default {
  'core.labels.deactivated': 'Deactivated',
};
